'use strict';

/**
 * @module views/markers/city
 * @author Sebastian Pekarek
 */

const DEBUG_DRAW_CITY_BOUNDS = false;

const MARKER_MIN_SIZE = 15;
const MARKER_MAX_SIZE = 60;
const MARKER_BORDER_MIN_FACTOR = 0.8;
const MARKER_BORDER_MAX_FACTOR = 0.3;

const Marker = require('./_');
const ConfigurationHelper = require('../../helpers/configuration');
const EventHelper = require('../../helpers/event');

class CityMarker extends Marker {
	constructor (city, map) {
		super({
			type: 'city',
			object: city,
			map
		});

		if (DEBUG_DRAW_CITY_BOUNDS) {
			this.bounds = new google.maps.Rectangle({
				strokeColor: this.debugColor,
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: this.debugColor,
				fillOpacity: 0.4,
				clickable: false,
				map: this.map.map,
				bounds: city.bounds
			});
		}
	}

	renderMarker () {
		const icon = {
			anchor: new google.maps.Point(MARKER_MAX_SIZE / 2, MARKER_MAX_SIZE / 2),
			size: new google.maps.Size(MARKER_MAX_SIZE * 1.2, MARKER_MAX_SIZE * 1.2),
			origin: new google.maps.Point((MARKER_MAX_SIZE * 1.2 - MARKER_MAX_SIZE) / -2, (MARKER_MAX_SIZE * 1.2 - MARKER_MAX_SIZE) / -2),
			scaledSize: new google.maps.Size(MARKER_MAX_SIZE, MARKER_MAX_SIZE),
			url: this.getCurrentCityMarkerUrl()
		};

		const marker = new google.maps.Marker({
			clickable: true,
			zIndex: 20,
			cursor: 'pointer',
			icon,
			map: this.map.map,
			optimized: false,
			infoWindow: null,
			position: new google.maps.LatLng(this.object.lat, this.object.lng),
			title: this.object.name
		});

		google.maps.event.addListener(marker, 'click', () => {
			EventHelper.selectCity(this.object);
		});
		google.maps.event.addListener(this.map.map, 'zoom_changed', () => {
			this.marker.setIcon(Object.assign({}, icon, {url: this.getCurrentCityMarkerUrl()}));
		});

		return marker;
	}
	getCurrentCityMarkerUrl () {
		const bounds = this.map.map.getBounds().toJSON();
		const sizeFactor = Math.max(
			(this.object.bounds.north - this.object.bounds.south) / (bounds.north - bounds.south),
			(this.object.bounds.east - this.object.bounds.west) / (bounds.east - bounds.west)
		) / 0.06 * MARKER_MAX_SIZE;
		const countFactor = Math.min(100, this.object.placeCount) / 100 * MARKER_MAX_SIZE;
		const size = (sizeFactor * .8 + countFactor * 5) / 2;
		return CityMarker.getCityMarkerUrl(size);
	}

	static getCityMarkerUrl (size = MARKER_MAX_SIZE) {
		size = Math.min(Math.max(Math.round(size), MARKER_MIN_SIZE), MARKER_MAX_SIZE);
		if(CityMarker.markerCache && CityMarker.markerCache[size]) {
			return CityMarker.markerCache[size];
		}

		const canvas = document.createElement('canvas');
		canvas.width = MARKER_MAX_SIZE * 3;
		canvas.height = MARKER_MAX_SIZE * 3;

		const maxRadius = size * 3 / 2;
		const lineWidthFactor = MARKER_BORDER_MIN_FACTOR + (
			(MARKER_BORDER_MAX_FACTOR - MARKER_BORDER_MIN_FACTOR) * (size / MARKER_MAX_SIZE)
		);
		const lineWidth = maxRadius * lineWidthFactor / 2;
		const radius = maxRadius - lineWidth;

		const context = canvas.getContext('2d');
		context.clearRect(0, 0, canvas.width, canvas.height);
		context.lineWidth = lineWidth;
		context.strokeStyle = ConfigurationHelper.getMarkerColor();
		context.arc(canvas.width / 2, canvas.height / 2, radius, 0, 2 * Math.PI);
		context.stroke();

		const url = canvas.toDataURL('image/png');
		CityMarker.markerCache = CityMarker.markerCache || {};
		CityMarker.markerCache[size] = url;
		return url;
	}
}

module.exports = CityMarker;
